import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'Testing',
                topics: [
                    'Byte code in your performance',
                    'Choosing an E2E Testing Solution',
                    'How you can test your Vue.js apps in less than seven minutes',
                    'Vue Test Utils for component testing',
                ],
            },
            {
                title: 'Major updates',
                topics: [
                    'Build Advanced Components in Vue 3 using $attrs',
                    'Problems With Server-Side Plugins in Nuxt.js',
                    'Pinia for State Management',
                    'Vuex vs Pinia & Migrating to Pinia from Vuex',
                    'Nuxt 3 - Major Upgrades, Breaking Changes and Differences',
                    'Migrating from Nuxt 2 to Nuxt 3',
                ],
            },
            {
                title: 'Usability',
                topics: [
                    `Custom JSX transforms that leverages Vue's runtime features`,
                    'How to Build a Full-Stack Single Page Application with Vue.js',
                    'Vetur, the VSCode extension for Single-File Component IDE support',
                    'Using Vue 3 PWA',
                    'Reusable Forms with Vue 3',
                    'New devtools extension with simultaneous Vue 2 / Vue 3 support and a plugin system that allows community libraries to hook into the devtools panels',
                ],
            },
            {
                title: 'Website',
                topics: [
                    'VuePress for Vue-based static site generation',
                    'Exploiting HTML Content / URL / Style Injection',
                    'Fullstack - Nuxt 3 and Firebase',
                ],
            },
            {
                title: 'Error checking',
                topics: [
                    'ESLint plugin for static style / error checking',
                    'How to prevent cross-site scripting (XSS) and cross-site request forgery (CSRF)',
                ],
            },
            {
                title: 'API',
                topics: [
                    'How to avoid Risky Vue API Endpoints',
                    'Vue 3 Composition API: ref() vs. reactive()',
                    'Introduction to Vite',
                    'Creating Vue Plugins',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li p2' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>What event is about</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;